import { create } from "zustand";
import { defaultSettings } from "./lib/settings";
import { loadSettingsFromStorage, saveSettingsToStorage } from "./lib/persistence";
export const useApp = create((set) => ({
    screen: "upload",
    settings: loadSettingsFromStorage(),
    rawMarkdown: "",
    bodyHtml: "",
    headings: [],
    images: [],
    wordCount: 0,
    filename: "buch.md",
    imageOverrides: {},
    setScreen: (screen) => set({ screen }),
    setSettings: (next) => set((state) => {
        const updated = typeof next === "function" ? next(state.settings) : next;
        saveSettingsToStorage(updated);
        return { settings: updated };
    }),
    resetSettings: () => {
        const d = defaultSettings();
        saveSettingsToStorage(d);
        set({ settings: d });
    },
    loadDocument: ({ rawMarkdown, bodyHtml, headings, images, wordCount, filename }) => 
    // Beim Laden eines neuen Dokuments alte Overrides verwerfen — sie gehörten
    // zur vorherigen Datei und wären jetzt mit falschen Bildern verknüpft.
    set({ rawMarkdown, bodyHtml, headings, images, wordCount, filename, imageOverrides: {}, screen: "editor" }),
    setRawMarkdown: (md) => set({ rawMarkdown: md }),
    setParsed: ({ bodyHtml, headings, images, wordCount }) => set({ bodyHtml, headings, images, wordCount }),
    addImageOverrides: (entries) => set((state) => ({ imageOverrides: { ...state.imageOverrides, ...entries } })),
    clearImageOverrides: () => set({ imageOverrides: {} }),
}));
